import * as React from 'react';
import styled from 'styled-components';
import {
  Checkbox as Box,
  CheckboxProps,
} from '@material-ui/core';

const Checkbox = ({
  color = 'primary',
  size = 'small',
  ...props
}: CheckboxProps) => (
  <StyledBox
    color={color}
    size={size}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

const StyledBox = styled(Box)`
  padding: 6px;
  border-radius: var(--radius-sm);
  transition: background-color var(--motion-fast)
    var(--ease-standard);

  &:hover {
    background-color: var(--primary-50);
  }

  &.Mui-focusVisible {
    box-shadow: var(--shadow-focus);
    background-color: var(--primary-50);
  }

  &.Mui-checked {
    color: var(--primary-600);
  }

  &.Mui-disabled {
    color: var(--neutral-300);
  }
`;

export default Checkbox;
